@if (isAdmin) {
<button type="button" class="data-export-btn" (click)="download()" [disabled]="fetching" [title]="'Download ' + filename + ' as CSV'">
    <i class="fa" [class.fa-download]="!fetching" [class.fa-spinner]="fetching" [class.fa-spin]="fetching"></i>
    <span class="data-export-btn__label">{{ label }}</span>
</button>
}
